import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * Unified subpage menu component for pages with multiple subpages.
 * Used for Pricing and Configuration pages.
 * 
 * @param {Object} props
 * @param {Array} props.subPages - Array of subpage definitions with id, name, displayName, and icon
 * @param {string} props.value - Current selected subpage name
 * @param {boolean} props.mobile - Whether to show mobile layout (horizontal tabs)
 * @param {string} props.menuId - Optional ID for the menu box
 * @param {string} props.ariaLabel - Optional aria-label for accessibility
 */
const SubPageMenu = (props) => {
  const { subPages, value, mobile, menuId, ariaLabel = "subpage tabs example" } = props;

  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    navigate(`../${newValue}`);
  }

  const mobileStyle = {
    width: "100%"
  }

  const desktopStyle = {
    width: "120px",
    minWidth: "120px"
  }

  return <Box id={menuId} sx={mobile ? mobileStyle : desktopStyle}>
    <Tabs
      orientation={mobile ? "horizontal" : "vertical"}
      value={value}
      onChange={handleChange}
      indicatorColor="secondary"
      aria-label={ariaLabel}
      variant="scrollable"
      scrollButtons={mobile}
      allowScrollButtonsMobile
    >
      {subPages.map(subPage => <Tab key={subPage.id} value={subPage.name} label={subPage.displayName} icon={subPage.icon} />)}
    </Tabs>
  </Box>
}

export default SubPageMenu;

